import React, { useEffect, useState } from "react";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import SingleStats from "./Components/SingleStats/SingleStats";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import Victor from "assets/vectordegree45.svg";
import Victor2 from "assets/Vector10.svg";
import Mission from "assets/content.svg";
import Visson from "assets/content2.svg";
import HomeAPI from "../../api/homeApi";
import ImagesCard from "../Home/Components/ImagesCard/ImagesCard";




const AboutUs = () => {

  const [AboutData, setAboutData] = useState(null);
  const [ClientReviewData, setClientReviewData] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await HomeAPI.getAboutData();
        const ClientReview = await HomeAPI.getClientReviewData();

        setAboutData(data);
        setClientReviewData(ClientReview)
      } catch (error) {
        console.error("Error fetching home data:", error);
      }
    };

    fetchData();
  }, []);


  return (
    <>
      <HelmetInfo titlePage={"من نحن"} />
      <div className="mt-[150px]" />
      <div className="main-container bg-[#fff] mx-auto px-4 py-8 ">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-4 max-w-screen-lg mx-auto">
          {/* Breadcrumb */}
          <BreadCrumb AboutData={AboutData} />

          {/* Title Section */}
          <div className="text-center flex items-center flex-col gap-6">
            <span className="text-lg font-medium text-[#0d6b70]">

            </span>
            <h1 className="text-4xl lg:text-[2.75rem] text_bold_Bukra text-[#0d6b70] leading-snug">
              {AboutData?.data?.sections[0]?.title}
            </h1>
            <p className="text-lg lg:text-[1rem] font-medium  w-[85%]  text-[#0d6b70] leading-relaxed">
              {AboutData?.data?.sections[0]?.Posts[0]?.title}

            </p>
          </div>
        </div>
        <div className="lg:w-[60%] mx-auto my-0 bg-white px-4 py-8 relative ">
          {/* Section 1: Company Intro */}
          <div className="mx-auto mb-10 text-center 29LT_Bukra text-[#667680] text-lg lg:text-[1rem] font-medium  leading-relaxed md:px-5">
            <p
              className="text-lg lg:text-[1rem] font-medium leading-relaxed md:tracking-wide"
              dangerouslySetInnerHTML={{
                __html: AboutData?.data?.sections[0]?.Posts[0]?.description || "",
              }}
            ></p>
          </div>
        </div>
        <div className="flex items-center relative">
          <div className="flex flex-col md:flex-row justify-start items-center rtl:w-[80%] ltr:w-[50%] lg:mx-auto  ltr:flex-row-reverse">
            <div className="  max-w-screen-md  text-start md:ps-0 md:py-10">
              <h3 className="text-sm md:text-base  text_small_Bukra text-[#1d1d1d] mb-1 leading-[29px] py-3">
            
                
              </h3>
              <h2 className="text-2xl md:text-[1.65rem] text_bold_Bukra text-[#0d6b70] leading-tight pb-5">
                {AboutData?.data?.sections[1]?.Posts[0]?.title}
              </h2>
            
              <p className="mt-4 text-[#667680] 29LT_Bukra text-sm md:text-base leading-[29px] lg:w-[56%] md:w-[70%]"
              dangerouslySetInnerHTML={{
              __html: AboutData?.data?.sections[1]?.Posts[0]?.description || "",
            }}>

              </p>
            </div>

            <div
              className=" w-full h-[150px] sm:w-[509px] lg:w-[710px] lg:h-[509.049px] bg-contain xl:bg-cover bg-no-repeat lg:absolute md:absolute lg:top-[-1.5px] rtl:left-[0%] ltr:right-[-9%]  rtl:md:translate-x-[-2.61%] ltr:rotate-y-180 z-[1] "
              style={{ backgroundImage: `url(${Victor})`, backgroundSize: "contain" }}
            ></div>

          </div>

        </div>

        <div className="flex items-center relative lg:my-48">
    <div className="flex flex-col md:flex-row justify-end items-center w-[75%] mx-auto max-sm:flex-col-reverse">

    <div
      className="w-full md:w-[325px] sm:w-[509px] lg:w-[710px] md:h-[509.049px] bg-contain xl:bg-cover bg-no-repeat md:absolute top-[-1.5px] rtl:right-[0] ltr:left-2 rotate-y-180 z-[1] max-sm:w-[334px] max-sm:h-[139px] md:top-[0]"
      style={{ backgroundImage: `url(${Victor2})`, backgroundSize: "contain" }}
    ></div>

    <div className="rtl:max-w-screen-md ltr:lg:max-w-screen-sm md:w-[468px] text-start md:ps-10 md:py-10 rtl:text-end">
      <h3 className="text-sm md:text-base text_small_Bukra text-[#1d1d1d] mb-1 leading-[29px] py-3">
        {AboutData?.data?.sections[1]?.title}
      </h3>
      <h2 className="text-2xl md:text-[1.65rem] text_bold_Bukra text-[#0d6b70] leading-tight pb-5 rtl:text-right">
        {AboutData?.data?.sections[2]?.Posts[0]?.title}
      </h2>
      <p className="mt-4 text-[#667680] 29LT_Bukra text-sm md:text-base leading-[29px] rtl:lg:w-[100%] ltr:lg:w-[65%] rtl:text-right md:w-[70%]"
      dangerouslySetInnerHTML={{
              __html: AboutData?.data?.sections[2]?.Posts[0]?.description || "",
            }}>
       
      </p>
    </div>
  </div>
</div>


        {/* <div className="main-container w-full bg-[#fff] relative mx-auto my-0 md:px-36 py-8 lg:mt-24">
          <div className="flex flex-col items-center gap-6 text-center mt-12">
            <div className="flex flex-col gap-2">
              <span className="text-lg font-medium text_small_Bukra text-[#1d1d1d]">{AboutData?.data?.sections[2]?.title}
              </span>
              <span className="text-2xl md:text-[1.65rem] text_bold_Bukra font-bold text-[#0d6b70] leading-snug">
                {AboutData?.data?.sections[3]?.Posts[0]?.title}
              </span>
            </div>
            <p className="text-sm md:text-base text_small_Bukra  text-[#667680] max-w-[90%] md:max-w-[706px] leading-relaxed" dangerouslySetInnerHTML={{
              __html: AboutData?.data?.sections[3]?.Posts[0]?.description || "",
            }}>
            </p>
          </div>

                  <ImagesCard ClientReviewData={ClientReviewData} />

        
        </div> */}
      </div>
    </>
  );
};

export default AboutUs;
